export default __webpack_public_path__ + "static/media/vigot-screenshot-04.ed673d37.png";